export const LOGIN_MODE = "LOGIN_MODE";
export const loginMode = mode => ({ type: LOGIN_MODE, mode });

export const SET_LOGIN_MESSAGE = "SET_LOGIN_MESSAGE";
export const setLoginMessage = message => ({
  type: SET_LOGIN_MESSAGE,
  message
});
